<template>
  <div class="bg">
    <div class="content">
      <el-card>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          status-icon
          label-width="auto"
          :inline-message="true"
          label-position="left"
        >
          <el-form-item label="人员姓名：">
            <span> {{ name }} </span>
          </el-form-item>
          <el-form-item label="合同模版：" prop="templateUrl">
            <span @click="showContractTemplatePopup = true">{{ templateUrl }}</span>
            <!-- <p
              v-if="templateUrl !== '请选择合同模版（选后可预览）'"
              style="text-align: right"
            >
              <el-button size="small" type="primary">
                <a :href="path" style="color: #fff" target="_blank">预览合同模版</a>
              </el-button>
            </p> -->
            <van-popup
              v-model="showContractTemplatePopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择合同模版"
                show-toolbar
                :columns="contractTemplateOptions"
                @confirm="onConfirmContractTemplate"
                @cancel="showContractTemplatePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="工资类型：" prop="type">
            <span @click="showTypePopup = true">{{ type }}</span>
            <van-popup
              v-model="showTypePopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择工资类型"
                show-toolbar
                :columns="typeOptions"
                @confirm="onConfirmType"
                @cancel="showTypePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item v-if="show === 1" label="日工资：" prop="dailyWage">
            <el-input v-model="form.dailyWage" size="small" placeholder="请输入日工资" />
          </el-form-item>
          <el-form-item v-else-if="show === 2" label="月工资：" prop="monthlySalary">
            <el-input
              v-model="form.monthlySalary"
              size="small"
              placeholder="请输入日工资"
            />
          </el-form-item>
          <div v-else-if="show === 3">
            <el-form-item label="元/（㎡）：" prop="unitPrice">
              <el-input
                v-model="form.unitPrice"
                size="small"
                placeholder="请输入元/（㎡）"
              />
            </el-form-item>
            <el-form-item label="造价占比：" prop="totalCostScore">
              <el-input
                v-model="form.totalCostScore"
                size="small"
                placeholder="请输入造价占比（%）"
              />
            </el-form-item>
          </div>

          <el-form-item label="生效日期：" prop="startTime">
            <div @click="showStartDatePopup = true">
              <i class="iconfont icon-riqi" />
              &nbsp;&nbsp;
              {{ startTime }}
            </div>
            <van-popup
              v-model="showStartDatePopup"
              round
              readonly="readonly"
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="请选择生效日期"
                :min-date="minDate"
                :max-date="maxDate"
                :overlay="true"
                @confirm="confirmStartDate"
                @cancel="showStartDatePopup = false"
              />
            </van-popup>
          </el-form-item>

          <el-form-item label="终止日期：">
            <div @click="showCompleteDatePopup = true">
              <i class="iconfont icon-riqi" /> &nbsp;&nbsp;{{ completeDate }}
            </div>
            <van-popup
              v-model="showCompleteDatePopup"
              round
              readonly="readonly"
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="请选择终止日期"
                :min-date="minDate"
                :max-date="maxDate"
                :overlay="true"
                @confirm="confirmCompleteDate"
                @cancel="showCompleteDatePopup = false"
              />
            </van-popup>
          </el-form-item>
          <div style="text-align: right">
            <el-button size="mini" type="primary" @click="goSign('form')"
              >前往电子签名</el-button
            >
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import formRules from "@/utils/formRules.js";
import { GetFindAll } from "@/api/app/contractTemplate";
import { postDetail, postSignContract } from "@/api/app/roster";
export default {
  data() {
    return {
      // 合同模版
      templateUrl: "请选择合同模版",
      contractTemplateOptions: [],
      showContractTemplatePopup: false,
      // 工资类型
      type: "请选择工资类型",
      show: Number,
      typeOptions: [
        {
          text: "日工资",
          value: 1,
        },
        {
          text: "月工资",
          value: 2,
        },
        {
          text: "计量工资",
          value: 3,
        },
      ],
      showTypePopup: false,
      // 生效日期
      showStartDatePopup: false,
      // 终止日期
      showCompleteDatePopup: false,
      name: "",
      path: "",
      startTime: "请选择生效日期",
      completeDate: "请选择终止日期",
      form: {
        templateUrl: "",
        type: "",
        dailyWage: "",
        startTime: "",
        monthlySalary: "",
        unitPrice: "",
        totalCostScore: "",
      },
      // 时间选择器
      minDate: new Date(),
      maxDate: new Date(new Date().getFullYear() + 2, 1, 1),
      currentDate: new Date(),
      rules: {
        templateUrl: [{ required: true, message: "合同模版不能为空" }],
        type: [{ required: true, message: "工资类型以及工资不能为空" }],
        dailyWage: [{ validator: formRules.validateNumber, message: "请输入正确格式" }],
        monthlySalary: [
          { validator: formRules.validateNumber, message: "请输入正确格式" },
        ],
        unitPrice: [{ validator: formRules.validateNumber, message: "请输入正确格式" }],
        totalCostScore: [
          { validator: formRules.validateNumber, message: "请输入正确格式" },
        ],
        startTime: [{ required: true, message: "工资类型以及工资不能为空" }],
      },
    };
  },
  created() {
    this.detail();
    this.getContractTemplate();
  },
  mounted() {},
  methods: {
    // 人员姓名
    detail() {
      this.form.ids=[this.$store.state.app.itemId];
      postDetail(JSON.stringify(this.$store.state.app.itemId)).then((res) => {
        this.name = res.data.name;
      });
    },
    // 获取通用合同模版
    getContractTemplate() {
      GetFindAll().then((res) => {
        this.contractTemplateOptions = res.data.map((item) => {
          return { text: item.name, ...item };
        });
      });
    },
    // 合同模版选择
    onConfirmContractTemplate(value) {
      this.templateUrl = value.name;
      this.form.templateUrl = value.url;
      this.path = value.path;
      this.showContractTemplatePopup = false;
    },
    // 工资类型选择
    onConfirmType(value) {
      this.show = value.value;
      this.type = value.text;
      this.form.type = value.value;
      this.showTypePopup = false;
    },
    // 合同生效日期选择
    confirmStartDate(value) {
      let date = this.datePick.datePick(value).substring(0, 10);
      this.startTime = date;
      this.form.startTime = date;
      this.showStartDatePopup = false;
    },
    // 合同终止日期
    confirmCompleteDate(value) {
      let date = this.datePick.datePick(value).substring(0, 10);
      this.completeDate = date;
      this.form.endTime = date;
      this.showCompleteDatePopup = false;
    },
    // 前往电子签名
    goSign(form) {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$store.commit("Content", this.form);
          this.form.ids = [this.$store.state.app.itemId];
          this.$router.push({ path: "/recruit/sign" });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bg {
  padding: 10px;
  min-height: 100vh;
  margin-bottom: 60px;
  background-color: #f0f0f0;
}
.content {
  .van-button {
    height: 100%;
  }
  span {
    font-size: 14px;
  }
  .el-card {
    margin-bottom: 10px;
    .iconfont {
      color: #b2bec3;
    }
    /deep/ .el-card__body {
      padding: 15px;
    }
    /deep/ .el-form-item {
      margin-bottom: 0px;
      .el-form-item__label {
        color: #000;
      }
      .el-input__inner {
        border: unset;
        padding: 0;
      }
    }
  }
}
</style>
